import { render, staticRenderFns } from "./MatchPage.vue?vue&type=template&id=445761c5"
import script from "./MatchPage.vue?vue&type=script&lang=js"
export * from "./MatchPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports